import React from "react";
import { useStaticQuery, graphql } from "gatsby";

// Components
import Home from "../layouts/home";
import SEO from "../components/seo/seo";
import PersonalizationCards from "../components/card/personalization-cards";
import LargePersonalizationCards from "../components/card/large-personalization-cards";
import ServiceStates from "../components/service-states/service-states";
import QuickLinks from "../components/quick-links/quick-links";
import BestBanksDefault from "../components/best-banks/best-banks-default";
import HeroChevron from "../components/hero/hero-chevron";

import getHeroImgVariables from "../helpers/getHeroImgVariables";

const IndexPage = () => {
  const pageData = useStaticQuery(graphql`
    {
      imgVariableXXL: file(relativePath: { eq: "hero/homepage/hero-homepage-free-checking-042325-XXL.jpg" }) {
        ...heroChevronImageFragmentXXL
      }
      imgVariableXL: file(relativePath: { eq: "hero/homepage/hero-homepage-free-checking-042325-XL.jpg" }) {
        ...heroChevronImageFragmentXL
      }
      imgVariableLG: file(relativePath: { eq: "hero/homepage/hero-homepage-free-checking-042325-LG.jpg" }) {
        ...heroChevronImageFragmentLG
      }
      imgVariableMD: file(relativePath: { eq: "hero/homepage/hero-homepage-free-checking-042325-MD.jpg" }) {
        ...heroChevronImageFragmentMD
      }
      imgVariableSM: file(relativePath: { eq: "hero/homepage/hero-homepage-free-checking-042325-SM.jpg" }) {
        ...heroChevronImageFragmentSM
      }
      imgVariableXS: file(relativePath: { eq: "hero/homepage/hero-homepage-free-checking-042325-XS.jpg" }) {
        ...heroChevronImageFragmentXS
      }
      imgVariableXXS: file(relativePath: { eq: "hero/homepage/hero-homepage-free-checking-042325-XXS.jpg" }) {
        ...heroChevronImageFragmentXXS
      }
    }
  `);

  const heroChevronData = {
    id: "home-page-hero",
    ...getHeroImgVariables(pageData),
    altText: "A Couple laughing while eating at an outdoor cafe.",
    heroBody: {
      components: [
        {
          id: 1,
          heading: {
            class: "text-white",
            text: "Get Everything You Need with *Free Checking"
          }
        },
        {
          id: 2,
          button: {
            id: "hero-cta-btn-1",
            text: "Open an Account",
            url: "/personal-banking/free-checking-account",
            class: "btn-white",
            containerClass: "mb-2"
          }
        },
        {
          id: 4,
          tertiaryText: {
            class: "text-white",
            text: "*Nonsufficient funds charge may apply."
          }
        }
      ]
    }
  };

  const SEOData = {
    title: "WaFd Bank: Bank Accounts, Small Business Banking, and Commercial Financing",
    description:
      "WaFd Bank, voted best bank, offers services including checking and savings accounts, business bank accounts, business financing, and commercial financing.",
    imagePath: "/og-images/homepage.jpg",
    imageAlt: heroChevronData.altText,
    imageDate: "042325",
    customTags: [{ name: "google-site-verification", content: "_mFadtR6nMvgpFsiuNrksFw-FqJ9tQ1MMSNbp6-8XtE" }],
    schema: {
      "@context": "https://schema.org",
      "@type": "Organization",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Seattle, Washington",
        postalCode: "98101",
        streetAddress: "425 Pike Street",
        description:
          "WaFd Bank, voted best bank, offers services including checking and savings accounts, business bank accounts, business financing, and commercial financing."
      },
      email: "info@wafd.com",
      phoneNumber: "800-324-9375"
    },
    addSuffix: false
  };

  return (
    <Home footerBorder={false}>
      <SEO {...SEOData} />
      <HeroChevron {...heroChevronData} />
      <QuickLinks />
      <section className="bg-info">
        <PersonalizationCards />
        <LargePersonalizationCards />
        <ServiceStates />
      </section>
      <BestBanksDefault />
    </Home>
  );
};

export default IndexPage;
